import { render, staticRenderFns } from "./GiftPostList.vue?vue&type=template&id=706ae120&scoped=true&"
import script from "./GiftPostList.vue?vue&type=script&lang=js&"
export * from "./GiftPostList.vue?vue&type=script&lang=js&"
import style0 from "./GiftPostList.vue?vue&type=style&index=0&id=706ae120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ae120",
  null
  
)

export default component.exports